import MainScreen from './screens/MainScreen'

function App() {
  return (
    <div className="App">
      <MainScreen/>
    </div>
  );
}

export default App;
